'use es6';

import styled from 'styled-components';
export var HiddenAriaStatus = styled.div.withConfig({
  displayName: "HiddenAriaStatus",
  componentId: "sc-1ekhs9d-0"
})(["position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;"]);